<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>推送设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-trade-pair @refresh="refreshList"></create-trade-pair>
      </div>
      <trade-pair-list @refresh="refreshList"></trade-pair-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import TradePairList from './components/list';
import CreateTradePair from './components/create';
import { mapActions, mapState } from 'vuex';
import { PAGINATION } from './constants';

export default {
  name: 'TradePairSetting',
  components: {
    TradePairList,
    CreateTradePair
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('pushsetting', ['pagination'])
  },
  methods: {
    ...mapActions('pushsetting', ['list']),
    refreshList(data = {}) {
      this.list({
        ...this.pagination,
        ...data
      });
    }
    // handleSearch() {
    //   this.list({
    //     ...this.pagination,
    //     page: 1
    //   });
    // },
  },
  mounted() {
    this.list({
      ...this.pagination
    });
  }
};
</script>

<style lang="less" scoped></style>
